import dayjs from "dayjs";

export function formatDate(date: any) {
  return dayjs(date).format("MMM DD YYYY");
}

export function formatTime(date: any) {
  return dayjs(date).format("HH:mm:ss");
}
